import { LocalStoreService } from "./LocalStoreService";

export class RedirectV2Service {
    LocalStoreService = new LocalStoreService();
    constructor() {}

    redirect({
        accountingId,
        source = null,
        companyId = null,
        routeId = null
    }) {
        const baseUrl = publicSettings.urlV2;
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `${baseUrl}/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (source) {
            url += `&source=${source}`;
        }
        if (routeId) {
            url += `&routeId=${routeId}`;
        }
        if (companyId) {
            url += `&companyId=${companyId}`;
        }

        window.location.href = url;
    }

    getUrl({
        accountingId,
        source = null,
        companyId = null,
        routeId = null,
        next = null,
        from = null
    }) {
        const baseUrl = publicSettings.urlV2;
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `${baseUrl}/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (source) {
            url += `&source=${source}`;
        }
        if (routeId) {
            url += `&routeId=${routeId}`;
        }
        if (companyId) {
            url += `&companyId=${companyId}`;
        }
        if (next) {
            url += `&next=${next}`;
        }
        // `from` diz ao v2 de onde a pessoa veio. O editor da DRE usa para devolver a esta tela
        // quando o cliente fechar, em vez de despeja-lo na customizacao do v2.
        if (from) {
            url += `&from=${encodeURIComponent(from)}`;
        }
        return url;
    }

    getCentralConsultivaUrl({ accountingId }) {
        return this.getUrl({ accountingId, next: "/carteira-consultiva" });
    }

    redirectToCentralConsultiva({ accountingId }) {
        if (!accountingId) return false;
        window.location.href = this.getCentralConsultivaUrl({ accountingId });
        return true;
    }

    getUrlBeta({ accountingId, next = null }) {
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `https://betta.nucont.com/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (next) {
            url += `&next=${next}`;
        }
        return url;
    }

    chatNucont({ accountingId }) {
        const baseUrl = publicSettings.chatNucont;
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `${baseUrl}/authenticate?accId=${accountingId}&rwt=${refreshToken}`;
        return url;
    }

    getUrlBeta({ accountingId, next = null }) {
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `https://betta.nucont.com/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (next) {
            url += `&next=${next}`;
        }
        return url;
    }
}
